import React from 'react'

const GoogleMaps = () => {
    return (
        <iframe className='gmaps' src=
            'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d10910.67150014194!2d24.88428362395202!3d60.15972224508193!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46920a5c11e5951b%3A0x13e3acc15d814db7!2sOctopussy%20Tattoos!5e0!3m2!1sen!2sfi!4v1616243965384!5m2!1sen!2sfi'
        allowFullScreen='' aria-hidden='false' loading='lazy' tab-index='0'>
        </iframe>
    )
}

export default GoogleMaps
